import React from 'react';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { ModalIntro } from 'components/layout/ModalIntro';
import userAdminSrc from 'assets/media/user-admin.png';
import { FormattedMessage } from 'react-intl';
import { ShouldRender } from '../../../../../ShouldRender';
import { Groups } from './components/Groups';
import { GroupForm } from './components/Groups/components/GroupForm';
import { AccessRules } from './components/AccessRules';
import { AccessRuleForm } from './components/AccessRules/components/AccessRuleForm';
import { AddAccessRuleForm } from './components/AccessRules/components/AddAccessRuleForm';
// import { Resources } from './components/Resources';
// import { ResourceForm } from './components/Resources/components/ResourceForm';
// import { AddResourceForm } from './components/Resources/components/AddResourceForm';
import { AddGroupForm } from './components/Groups/components/AddGroupForm';
import { TimeProfiles } from './components/TimeProfiles';
import { TimeProfileForm } from './components/TimeProfiles/components/TimeProfileForm';
import { AddTimeProfileForm } from './components/TimeProfiles/components/AddTimeProfileForm';
import { AccessManagement2NModalProvider } from './components/AccessManagement2NModalContext/AccessManagement2NModalProvider';
import { useAccessManagement2NModal } from './components/AccessManagement2NModalContext/useAccessManagement2NModal';

const AccessManagement2NModalContent = () => {
  const {
    activeTab,
    isAdding,
    switchTab,
  } = useAccessManagement2NModal();

  const {
    showAccessRules,
    showGroups,
    showTimeProfiles,
    // showResources,
  } = activeTab;

  const {
    group: isAddingGroup,
    accessRule: isAddingAccessRule,
    timeProfile: isAddingTimeProfile,
    // resource: isAddingResource,
  } = isAdding;

  return (
    <Grid brikkLayout>
      <IntlPageTitle intlTitle="twoNAccessManagement" />

      <Grid.Column>
        <Brikk.Heading
          main
          heading="twoNAccessManagement"
        >
          <ModalIntro>
            <ModalIntro.Image
              src={userAdminSrc}
              alt="twoNAccessManagement"
            />

            <div>
              <ModalIntro.Card onClick={() => switchTab('showAccessRules')}>
                <FormattedMessage id="accessRulesTitle" />
              </ModalIntro.Card>
              <ModalIntro.Card onClick={() => switchTab('showGroups')}>
                <FormattedMessage id="accessGroupsTitle" />
              </ModalIntro.Card>

              <ModalIntro.Card onClick={() => switchTab('showTimeProfiles')}>
                <FormattedMessage id="timeProfiles" />
              </ModalIntro.Card>
              {/*<ModalIntro.Card onClick={() => switchTab('showResources')}>*/}
              {/*  <FormattedMessage id="accessGroupsResourcesTitle" />*/}
              {/*</ModalIntro.Card>*/}

            </div>
          </ModalIntro>
        </Brikk.Heading>

      </Grid.Column>

      <ShouldRender condition={showAccessRules}>
        <Grid.Column>
          <AccessRules />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showGroups}>
        <Grid.Column>
          <Groups />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showGroups && isAddingGroup}>
        <Grid.Column>
          <AddGroupForm />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showAccessRules && isAddingAccessRule}>
        <Grid.Column>
          <AddAccessRuleForm />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showGroups && !isAddingGroup}>
        <Grid.Column>
          <GroupForm />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showTimeProfiles}>
        <Grid.Column>
          <TimeProfiles />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showTimeProfiles && isAddingTimeProfile}>
        <Grid.Column>
          <AddTimeProfileForm />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showTimeProfiles && !isAddingTimeProfile}>
        <Grid.Column>
          <TimeProfileForm />
        </Grid.Column>
      </ShouldRender>

      <ShouldRender condition={showAccessRules && !isAddingAccessRule}>
        <Grid.Column>
          <AccessRuleForm />
        </Grid.Column>
      </ShouldRender>

      {/*<ShouldRender condition={showResources}>*/}
      {/*  <Grid.Column>*/}
      {/*    <Resources />*/}
      {/*  </Grid.Column>*/}
      {/*</ShouldRender>*/}

      {/*<ShouldRender condition={showResources && isAddingResource}>*/}
      {/*  <Grid.Column>*/}
      {/*    <AddResourceForm />*/}
      {/*  </Grid.Column>*/}
      {/*</ShouldRender>*/}

      {/*<ShouldRender condition={showResources && !isAddingResource}>*/}
      {/*  <Grid.Column>*/}
      {/*    <ResourceForm />*/}
      {/*  </Grid.Column>*/}
      {/*</ShouldRender>*/}

    </Grid>
  );
};

export const AccessManagement2NModal = () => (
  <AccessManagement2NModalProvider>
    <AccessManagement2NModalContent />
  </AccessManagement2NModalProvider>
);

